import {
  ForwardedRef,
  forwardRef,
  HTMLAttributes,
  useCallback,
  useEffect,
} from 'react'
import styles from './Menu.module.scss'
interface MenuProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean
  className: string
  handleClose: () => void
  menuButtonId: string
  handleAction?: () => void
}
const Menu = forwardRef(function Menu(
  {
    children,
    open,
    className = '',
    handleClose,
    menuButtonId,
    handleAction,
    ...props
  }: MenuProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const handleClickOutside = useCallback(
    event => {
      const filterChips = document.getElementById(menuButtonId)
      const refElement = ref && typeof ref !== 'function' ? ref.current : null
      if (
        refElement &&
        !refElement.contains(event.target) &&
        filterChips &&
        !filterChips.contains(event.target)
      ) {
        handleAction && handleAction()
        handleClose()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleClose],
  )

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open, handleClickOutside])
  return (
    <div
      ref={ref}
      className={`
        ${styles['menu-container']} ${open ? styles['open'] : styles['close']} ${className}
      `}
      {...props}
    >
      {children}
    </div>
  )
})
export default Menu
